import { AppConfigOverride } from '@abstractTypes/envs'

const getMasterEnvVariables = () => {
  const masterEnvVariables: AppConfigOverride = {}

  return masterEnvVariables
}

export default getMasterEnvVariables
